import type { ReactNode } from 'react';
import type { ILink } from '@anywayseo/tools';
import type { Localized } from 'content/data';
import { StaticImage } from 'gatsby-plugin-image';

export interface IAlternativeCasino {
  id: number;
  name: string;
  image: ReactNode;
  header: string;
  features: string[];
  footer?: string;
  link: ILink;
}

const LinkLabelMap: Localized<string> = {
  de: 'Boni anzeigen',
  en: 'GET BONUS',
};

const LizaroLogo = (
  <StaticImage
    src='./assets/logo-lizaro.webp'
    alt='Lizaro Casino Logo'
    objectFit='contain'
    style={{ aspectRatio: '16/9', width: '100%' }}
  />
);

const CasinoLabLogo = (
  <StaticImage
    src='./assets/logo-casino-lab.png'
    alt='CasinoLab Logo'
    objectFit='contain'
    style={{ aspectRatio: '16/9', width: '100%' }}
  />
);

const GransinoLogo = (
  <StaticImage
    src='./assets/logo-gransino.png'
    alt='Gransino Logo'
    objectFit='contain'
    style={{ aspectRatio: '16/9', width: '100%' }}
  />
);

const CaseaLogo = (
  <StaticImage
    src='./assets/logo-casea.png'
    alt='Casea Logo'
    objectFit='contain'
    style={{ aspectRatio: '16/9', width: '100%' }}
  />
);

export const alternativeCasinos: Localized<IAlternativeCasino[]> = {
  de: [
    {
      id: 1,
      name: 'Lizaro Casino',
      image: LizaroLogo,
      header: '🎁 Willkommenspaket 250% bis zu 3000€ + 350FS',
      features: [
        '🎰 Erhalten Sie bis zu 250% auf Ihre erste Einzahlung',
        '🎲 350 Freispiele in Top-Slots',
        '💰 Wöchentlicher Cashback 15% bis zu 3000€',
        '🔄 Reload-Bonus am Wochenende 700€ + 50 Freispiele',
        '🎮 Live Casino Cashback 25% bis zu 200€',
      ],
      link: { url: 'https://liro.lynmonkel.com/?mid=320014_2022792', label: LinkLabelMap['de'] },
    },
    {
      id: 2,
      name: 'CasinoLab',
      image: CasinoLabLogo,
      header: '🎁 Willkommensbonus 100% bis zu 500€ + 200 Freispiele + 1 Bonus Crab 🦀',
      features: [
        '🎰 Verdoppeln Sie Ihre erste Einzahlung bis zu 500€',
        '🎲 200 Freispiele bei Registrierung',
        '💎 Täglicher Cashback 15% bis zu 400€',
        '🔄 Wöchentlicher Reload-Bonus 50 Freispiele',
        '⚡ Riesige Auswahl an Slots und Live-Spielen — über 10.000 Spiele',
      ],
      link: { url: 'https://cnl.lynmonkel.com/?mid=320014_2017581', label: LinkLabelMap['de'] },
    },
    {
      id: 3,
      name: 'Gransino Casino',
      image: GransinoLogo,
      header: '🎁 Willkommensbonus 100% bis zu 500€ + 200FS',
      features: [
        '🎰 100% Bonus auf die erste Einzahlung',
        '🎲 200 Freispiele in Premium-Slots',
        '💰 Reload-Bonus am Wochenende 700€ + 50 Freispiele',
        '🔄 Wöchentlicher Reload-Bonus 50 Freispiele',
        '🎮 Live Cashback 25% bis zu 200€',
      ],
      link: { url: 'https://grn.lynmonkel.com/?mid=320014_2022795', label: LinkLabelMap['de'] },
    },
  ],
  en: [
    {
      id: 1,
      name: 'Lizaro Casino',
      image: LizaroLogo,
      header: '🎁 Welcome Package 350% up to €16,000 + 350 FS',
      features: [
        '🎰 350% spread across your first four deposits',
        '🎲 350 free spins on top slots',
        '💰 Minimum deposit €10',
        '🔄 Wagering 20x (deposit + bonus), 40x on free spin winnings',
        '⚡ Casino, live casino, sportsbook and jackpots in one account',
      ],
      link: { url: 'https://liro.lynmonkel.com/?mid=320014_2022792', label: LinkLabelMap['en'] },
    },
    {
      id: 2,
      name: 'Casea Casino',
      image: CaseaLogo,
      header: '🎁 Crypto Welcome Bonus 350% up to 21,000 USDT + 350 FS',
      features: [
        '🪙 Crypto-only offer: USDT, Bitcoin, Bitcoin Cash, Litecoin, Ethereum, Ripple, USD Coin',
        '🎰 350% across your first four deposits — up to 21,000 USDT',
        '🎲 350 free spins included',
        '💰 Minimum deposit — €10, or 100 USDT for the crypto offer',
        '🔄 Wagering 20x (deposit + bonus), 40x on free spin winnings',
      ],
      link: { url: 'https://csa.lynmonkel.com/?mid=320014_2221889', label: LinkLabelMap['en'] },
    },
    {
      id: 3,
      name: 'CasinoLab',
      image: CasinoLabLogo,
      header: '🎁 Welcome Package 350% up to €16,000 + 350 FS in 4 bonuses',
      features: [
        '🎰 Four welcome bonuses — 100% / 100% / 50% / 100%',
        '🎲 350 free spins across the package',
        '💰 Minimum deposit €10',
        '🔄 Wagering 20x (deposit + bonus), 40x on free spin winnings',
        '🃏 Collections, tournaments, challenges and Shop on top of the welcome offer',
      ],
      link: { url: 'https://cnl.lynmonkel.com/?mid=320014_2017581', label: LinkLabelMap['en'] },
    },
  ],
};
